import { Box, Button, TextField } from '@mui/material'
import { updateRedisTransferOrder } from 'api'
import Header from 'components/Header'
import { SnackbarSeverity } from 'constant'
import { LoadingContext } from 'contexts/LoadingContextProvider'
import { OrderContext } from 'contexts/OrderContextProvider'
import { SnackContext } from 'contexts/SnackContextProvider'
import { useContext, useEffect, useRef, useState } from 'react'

const UpdateTransferOrderCache = () => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [error, setError] = useState(false)
  const [orderNumber, setOrderNumber] = useState('')
  const { company } = useContext(OrderContext)
  const { setLoading } = useContext(LoadingContext)
  const { handleOpenSnackbar } = useContext(SnackContext)

  const handleSubmit = async () => {
    if (!orderNumber) {
      setError(true)
      return
    }
    setLoading(true)
    try {
      const result = await updateRedisTransferOrder(company, orderNumber)
      if (result.data.success) {
        handleOpenSnackbar(
          SnackbarSeverity.Success,
          'Transfer Order Cache Updated'
        )
      } else {
        handleOpenSnackbar(
          SnackbarSeverity.Error,
          'Fail to Update Transfer Order Cache'
        )
      }
    } catch (error: any) {
      handleOpenSnackbar(SnackbarSeverity.Error, error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleKeyDown = async (event: any) => {
    if (event.key === 'Enter') {
      handleSubmit()
    }
  }

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <>
      <Header />
      <Box
        onKeyDown={handleKeyDown}
        sx={{
          margin: '50px 20px'
        }}
      >
        <TextField
          autoFocus
          inputRef={inputRef}
          label='Transfer Order Number'
          fullWidth
          value={orderNumber}
          error={error}
          helperText={error && 'Invalid transfer order number'}
          onChange={e => {
            setError(false)
            setOrderNumber(e.target.value)
          }}
        />
        <Button
          variant='contained'
          sx={{ display: 'block', margin: '50px auto', padding: '10px 25px' }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Box>
    </>
  )
}

export default UpdateTransferOrderCache
